import getJSONFromFile from '@/util/fileUtility'

const UKFPSSettings = getJSONFromFile('UKFPS.json')

export default UKFPSSettings
